<template>
  <div>
    <a-action-buttons-bar class="mb-3" :buttons="buttons">
    </a-action-buttons-bar>

    <v-data-table
      v-model="table.selected"
      :items="table.rows"
      :headers="table.headers"
      :loading="$api.loading('account/tokens/api')"
    >
      <template v-slot:item.last_used_at="{ item }">
        {{ $helpers.present.date(item.last_used_at) }}
      </template>
      <template v-slot:item.created_at="{ item }">
        {{ $helpers.present.date(item.created_at) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn small icon color="primary" @click="$ui.openDialog('delete_api_token', { id: item.id })">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'AApiWidget',
  data () {
    return {
      buttons: [
        {
          color: 'success',
          text: this.$t('create-new-token'),
          icon: 'mdi-plus',
          click: () => this.$ui.openDialog('create_api_token'),
        }
      ],
      table: {
        headers: [
          { text: 'Name', value: 'label' },
          { text: 'Last used at', value: 'last_used_at' },
          { text: 'Created at', value: 'created_at' },
          { text: 'Actions', value: 'actions', cellClass: 'smallest' },
        ],
        rows: [],
        selected: []
      }
    }
  },
  methods: {
    async fetch () {
      this.table.rows = (await this.$api.get('account/tokens/api', null, { showLoading: false })).data
    }
  },
  async mounted () {
    await this.fetch()
    this.$bus.on('refresh_api_token_table', this.fetch)
  },
  destroyed () {
    this.$bus.off('refresh_api_token_table', this.fetch)
  }
}
</script>

<style scoped>

</style>

<i18n>
{
	"en": {
		"create-new-token": "Create a new token"
	},
	"es": {
		"create-new-token": "Crea un token nuevo"
	},
	"fr": {
		"create-new-token": "Créer un nouveau token"
	},
	"it": {
		"create-new-token": "Crea un nuovo token"
	},
	"pt": {
		"create-new-token": "Criar um novo token"
	},
	"pl": {
		"create-new-token": "Utwórz nowy token"
	}
}
</i18n>
